<template>
  <v-btn
    x-small
    fab
    :color="getLogColor(item.incidents_status)"
    elevation="0"
    :to="{
      name: 'incidents',
      params: {
        project_id: item.id
      }
    }"
  >
  </v-btn>
</template>
<script>
export default {
  name: "StatusItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  methods: {
    getLogColor(level) {
      return (
        {
          ok: "success",
          warning: "warning",
          error: "error"
        }[level] ||
        level ||
        "warning"
      );
    }
  }
};
</script>

<style scoped></style>
